import React from 'react'
import { makeStyles, FormControl } from '@material-ui/core'
import {
   MuiPickersUtilsProvider,
   KeyboardDatePicker
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import esLocale from 'date-fns/locale/es'

const useStyles = makeStyles(theme => ({
   datepickerContainer: {
      margin: theme.spacing(2, 0, 1),
      width: '100%'
   },
   datePicker: {
      width: '100%'
   }
}))

function DatePickerField({
   fieldLabel,
   fieldName,
   formValue,
   handleChange,
   format = 'dd-MM-yyyy',
   minDate = new Date(),
   minDateMessage = 'La fecha no puede ser inferior a 01-01-1900',
   maxDateMessage = 'La fecha no puede ser mayor a 01-01-2100',
   invalidDateMessage = 'Seleccione una fecha válida',
   size,
   ...otherProps
}) {
   const classes = useStyles()
   return (
      <div className={classes.datepickerContainer}>
         <FormControl fullWidth>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
               <KeyboardDatePicker
                  className={classes.datePicker}
                  value={formValue}
                  label={fieldLabel}
                  format={format}
                  minDate={minDate}
                  name={fieldName}
                  InputAdornmentProps={{ position: 'end' }}
                  onChange={date =>
                     handleChange({
                        target: {
                           name: fieldName,
                           value: date
                        }
                     })
                  }
                  maxDateMessage={maxDateMessage}
                  minDateMessage={minDateMessage}
                  invalidDateMessage={invalidDateMessage}
                  variant="inline"
                  inputVariant="outlined"
                  size={size}
                  autoOk
                  clearable
                  {...otherProps}
               />
            </MuiPickersUtilsProvider>
         </FormControl>
      </div>
   )
}

export default DatePickerField
